export const ShapeDivider = ({ fill = '#120836', bg = 'transparent', flip = false }) => (
  <div aria-hidden="true" style={{ lineHeight: 0, background: bg, marginTop: '-1px', marginBottom: '-1px' }}>
    <svg viewBox="0 0 1440 56" preserveAspectRatio="none"
      className={`block w-full h-[40px] sm:h-[52px] ${flip ? 'rotate-180' : ''}`}>
      <path d="M0,0 L1440,0 L1440,14 C1080,56 360,56 0,14 Z" fill={fill} />
    </svg>
  </div>
);

export default ShapeDivider;
